import { render, staticRenderFns } from "./HandoverDetailDialog.vue?vue&type=template&id=4d26fbc0&scoped=true"
import script from "./HandoverDetailDialog.vue?vue&type=script&lang=js"
export * from "./HandoverDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./HandoverDetailDialog.vue?vue&type=style&index=0&id=4d26fbc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d26fbc0",
  null
  
)

export default component.exports